import { css, IconButton, styled } from '@mui/material';
import { CaretLeftIcon, CaretRightIcon } from '@phosphor-icons/react';

import { useUIStore } from '@/stores/useUIStore';
import { transientOptions } from '@/utils/transient-options';

const StyledFooter = styled(
  'footer',
  transientOptions,
)<{ $sidebarExpanded: boolean }>(
  ({ theme, $sidebarExpanded }) => css`
    display: flex;
    justify-content: ${$sidebarExpanded ? 'flex-start' : 'center'};
    margin-top: auto;
    padding-bottom: ${theme.spacing(1)};
    padding-left: ${$sidebarExpanded ? theme.spacing(1) : 'inherit'};
  `,
);

const StyledIconButton = styled(IconButton)(
  ({ theme }) => css`
    width: ${theme.spacing(6)};
    height: ${theme.spacing(6)};
    border-radius: ${theme.spacing(1)};
    display: flex;
    align-items: center;
    justify-content: center;
  `,
) as typeof IconButton;

export function Footer() {
  const sidebarExpanded = useUIStore((state) => state.sidebarExpanded);
  const { toggleSidebar } = useUIStore((state) => state.actions);

  return (
    <StyledFooter $sidebarExpanded={sidebarExpanded}>
      <StyledIconButton onClick={toggleSidebar}>
        {sidebarExpanded ? <CaretLeftIcon /> : <CaretRightIcon />}
      </StyledIconButton>
    </StyledFooter>
  );
}
